import { inIframe } from './inIframe';
import { isScriptLoadingCompleted, loadScript } from './scriptUtils';

const APPLE_PAY_SDK_URL = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
const SCRIPT_ID = 'apple-pay-sdk';

export const loadApplePayScript = async (demoMode?: boolean): Promise<void> => {
  if (inIframe() && !demoMode) {
    return;
  }

  const existingScript = document.getElementById(SCRIPT_ID);
  if (existingScript) {
    await isScriptLoadingCompleted(existingScript);
    return;
  }

  await loadScript(
    {
      src: APPLE_PAY_SDK_URL,
      crossorigin: 'anonymous',
      async: true,
    },
    SCRIPT_ID,
  );
};
